var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ContractorViewAdditionalFilters", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showAdditionalFilters,
            expression: "showAdditionalFilters",
          },
        ],
        attrs: { shouldClearFilters: _vm.shouldClearFilters },
        on: {
          filtersChanged: _vm.handleFiltersChanged,
          appliedFiltersNumberChanged: _vm.handleAppliedFiltersNumberChanged,
          filtersReset: function ($event) {
            return _vm.$emit("filtersReset")
          },
          rangeStart: _vm.handleTimeRangeChanged,
          rangeEnd: _vm.handleTimeRangeChangedEnd,
          close: _vm.handleIconClose,
        },
      }),
      _c(
        "LoadingOverlay",
        {
          staticClass: "w-full",
          attrs: {
            customPlaceholderMessage: _vm.customPlaceholderMessage,
            loading: _vm.loading,
            hasData: !!_vm.contractors.length,
          },
        },
        [
          _vm.contractors
            ? _c("Scheduler", {
                ref: "timeline",
                staticClass: "mb-10",
                attrs: {
                  groups: _vm.contractorGroups,
                  items: _vm.contractorActivityItems,
                  customOptions: _vm.options,
                  currentUser: _vm.currentUser,
                },
                on: {
                  rangechanged: _vm.rangeChanged,
                  select: _vm.handleSelect,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "group",
                      fn: function ({ group }) {
                        return [
                          group
                            ? _c("EmployeeGroup", {
                                attrs: { employeeItem: group },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          item
                            ? _c("ContractorViewActivityItem", {
                                attrs: {
                                  activity: item,
                                  overlappingActivityIds:
                                    _vm.getOverlappingActivities(item),
                                },
                                on: { create: _vm.handleCreateBtnClicked },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3825819758
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              projectActivity: _vm.activityInfoForModal,
              project: _vm.projectInfoForModal,
              currentUserRole: _vm.currentUser.role,
              contractorId: _vm.contractorIdForModal,
              isEdittingLocked: _vm.shouldBlockEditting,
              companyId: _vm.companyId,
            },
            on: {
              activityAdded: _vm.handleCollectionUpdated,
              activityUpdated: _vm.refetchCollection,
              close: _vm.handleCloseModal,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customHeader",
                  fn: function ({ title }) {
                    return [
                      _c("SchedulerCustomModalHeader", {
                        attrs: {
                          linkObject: _vm.linkToContractorProjects,
                          buttonText: title,
                          isEdittingLocked: _vm.shouldBlockEditting,
                          linkText: "Go To Contractor's Project List",
                        },
                        on: { editClicked: _vm.handleEditClick },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              3647239482
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }